<template>
	<div class='gPageBorder'>
    <el-form class='gForm' ref="submitForm" label-position="right" label-width="12.5%" :model="submitForm" :rules="editRules" style="width: 60%">
      <el-form-item :label="$t('menuConfig.role.name')" prop="roleName">
        <el-input v-model="submitForm.roleName"></el-input>
      </el-form-item>
      <el-form-item :label="$t('menuConfig.role.mark')" prop="memo">
        <el-input v-model="submitForm.memo"></el-input>
      </el-form-item>

      <el-form-item :label="$t('menuConfig.role.modelSelect')" prop="memo">
        <el-row>
      <el-col :span="16">
        <el-tree
          ref="tree"
          show-checkbox
          :data="resultData"
          :props="defaultProps"
          node-key="menuId"
          default-expand-all
          :expand-on-click-node="false">
            </el-tree>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <!-- <el-row>
      <el-col :span="24">
        <h2 style="margin:10px 0;">{{$t('menuConfig.role.modelSelect')}}</h2>
      </el-col>
    </el-row> -->


    <!-- <el-row>
      <el-col :span="16">
        <el-tree
          ref="tree"
          show-checkbox
          :data="resultData"
          :props="defaultProps"
          node-key="menuId"
          default-expand-all
          :expand-on-click-node="false">
        </el-tree>
      </el-col>
    </el-row> -->


    <el-form label-position="left" label-width="90px" style="width: 60%;margin-top: 10px;">
      <el-form-item>
        <el-button @click="checkAll()"><template v-if="!alreadyCheckAll">{{$t('mao_global.btn.selectAll')}}</template><template v-else>{{$t('mao_global.btn.unSelectAll')}}</template></el-button>
        <el-button @click="resetForm()">{{$t('mao_global.btn.reset')}}</el-button>
        <el-button type="primary" @click="addRole()">{{$t('mao_global.btn.createNow')}}</el-button>
      </el-form-item>
    </el-form>
	</div>

</template>

<script>
  import axios from 'axios'
  import { baseurl } from '../../api/url'
  import jq from 'jquery'
	export default{
    data(){
			return {
				// 提交的表单
				submitForm: {
          roleName: "",
          memo: "",
          token: localStorage.getItem('user'),
          menuId: "",
          subId: ""
        },
        planeMenuList: [],
        menuList: [],
        editRules: {
          roleName:[
            { required: true, message: this.$t('menuConfig.role.notBlankName'), trigger:'blur'}
          ]
        },
        // 菜单列表
        resultData: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        alreadyCheckAll: false
      }
		},
    mounted () {
    	var that = this
      that.fetchData()
		},
		methods:{
    	// 重置表单
    	resetForm () {
        var that = this

        // 取消选中模块
        that.alreadyCheckAll = false
        this.$refs.tree.setCheckedKeys([]);

        this.$refs['submitForm'].resetFields();

      },
    	// 全选
    	checkAll () {
        var that = this
        if (that.resultData && that.resultData.length>0) {
          that.alreadyCheckAll = !that.alreadyCheckAll

          if (that.alreadyCheckAll == true) {
            var checkArray = []
            for (var i=0; i< that.resultData.length; i ++) {
              checkArray.push(that.resultData[i]['menuId'])
            }

            if (checkArray.length > 0) {
              this.$refs.tree.setCheckedKeys(checkArray);
            }
          } else {
            this.$refs.tree.setCheckedKeys([]);
          }

        }
      },
    	// 提交角色数据
    	addRole () {
    		var that = this

        this.$refs['submitForm'].validate(function (result) {
          if(result){
            if (that.getCheckedKeysTwo() !== "") {
              that.submitForm.subId = that.getCheckedKeysTwo()

            }
            console.log('subId.........')
            console.log(JSON.stringify(that.submitForm.subId, null, 2))

            axios.post(`${baseurl}/role/addRole.do`,that.submitForm).then(res=>{
              if (res.data && res.data.status && res.data.status === 200) {
                that.$message(this.$t('menuConfig.role.addSuccess'))
//                that.$message(this.$t('menuConfig.role.updateSuccess'))
                that.$router.push({path: '/roleManager'})
              }
            })
          }
        }.bind(that));
      },
      getCheckedKeysTwo () {

        let resultSubIdString = ""

        // debugger
        // 获得所有菜单平铺的列表, 没有层级关系
        var copyPlaneMenuData = jq.extend(true,[],this.planeMenuList)

        // 获得选中打钩的所有菜单项menuId (这里是menuId)
        var checkKeysList = this.$refs.tree.getCheckedKeys();


        console.log(checkKeysList)
        // 通过menuId关联出当前选择对象
        let getObjectByMenuId = (menuId) => {
          let currentObj = null

          // 获取到平铺列表的总长度
          let len = copyPlaneMenuData.length

          // 循环找出对象
          for (var i=0; i < len; i++) {
            // 平铺列表中的某个对象
            let o = copyPlaneMenuData[i]
            if (o.menuId === menuId) {
              currentObj = o
              break;
            }
          }

          return currentObj
        }

        // 根据菜单id关联出 subId
        let getSubIdByMenuId = (menuId) => {
          // 根据menuId查询出来的对象
          let cObject = getObjectByMenuId(menuId)
          // 如果能查询出该对象, 则证明一定存在subId, 或许存在 superId
          if (cObject) {
            resultSubIdString += cObject.subId + ","
            copyPlaneMenuData = copyPlaneMenuData.filter( child => {
              if (menuId !== child.menuId) {
                return child
              }
            })
            if (cObject.superId && cObject.superId !== "0") {
              // 过滤菜单,减少循环次数
              getSubIdByMenuId(cObject.superId)
            }
          }
        }

        // 遍历所有选中的节点(menuId)关联出所有父级的subId
        if (checkKeysList && checkKeysList.length > 0) {
          let leng = checkKeysList.length
          for (var i=0; i < leng; i++) {
            // 选中列表中, 其中一个 menuId
            let selectMenuId = checkKeysList[i]
            getSubIdByMenuId(selectMenuId)
          }
        }

        return resultSubIdString.substring(0,resultSubIdString.length-1)
      },
      // getCheckedKeys() {
      //
    	// 	var resultData = ""
      //
    	// 	var checkKeysList = this.$refs.tree.getCheckedKeys();
    	// 	if (checkKeysList && checkKeysList.length > 0) {
    	// 		for (var i=0; i<checkKeysList.length; i++) {
      //       resultData += checkKeysList[i] + ","
      //     }
      //
      //     resultData = resultData.substring(0,resultData.length-1)
      //   }
      //
      //   return resultData
      // },
      // 获取初始化数据
      fetchData () {
        var that = this

        // 获取平面化的菜单列表
        var re = [];
        var toPlaneMenuList = (data) => {
          data.forEach((value)=>{
            var tmp = null
            if (value.children) {
              var tChildNode =  jq.extend(true,{},value)
              delete tChildNode.children
              re.push(tChildNode)
              tmp =  toPlaneMenuList(value.children)
            } else {
              tmp = value
            }
            if (tmp) re.push(tmp)
          })
        };

        axios.post(`${baseurl}/menu/getAllMenu.do`,{token: localStorage.getItem('user')}).then(res=>{
          if (res.data && res.data.status && res.data.status === 200) {
            that.resultData = res.data.data

            toPlaneMenuList(that.resultData)

            that.planeMenuList = re;
          }
        })
      }
		}
	}
</script>



// WEBPACK FOOTER //
// role-add.vue?092122bc